import { render, staticRenderFns } from "./DrawingFullScreenView.vue?vue&type=template&id=398b5ef7"
import script from "./DrawingFullScreenView.vue?vue&type=script&lang=js"
export * from "./DrawingFullScreenView.vue?vue&type=script&lang=js"
import style0 from "./DrawingFullScreenView.vue?vue&type=style&index=0&id=398b5ef7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports